<mat-dialog-content>
    <!-- <h1>Success!</h1> -->
    <p>{{ message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
  